import { CsdField, CSDContacts } from './daily-report'
import ServiceLocator from 'live/services/service-locator'
import { LiveApi } from 'live/lib/api'
import i18n from 'live/services/i18n'
import authorization from 'live/services/authorization'

try {
    document.addEventListener('DOMContentLoaded', function() {
        require('./init')
    })
} catch (e) {
    console.log(e)
}

ServiceLocator.getService('intervention-service').then(s => {
    s.dailyReportAdditionalFieldRegistry.register(CsdField)
    s.dailyReportAdditionalFieldRegistry.register(CSDContacts)
})

ServiceLocator.getService('flag-source-service').then(service => {
    service.flgEnableSourceField = true
})

require('./sitop/app')
require('./activity_log/app')
require('./samter/app')
require('./sest/app')
require('./rig_supervisors_management/app')
require('./sisp/app')
require('./pressure-tests-specification/app')
require('./witsml_qgog/app')

const userPermissions = authorization.Permission
const permissions = [
    {
        label: i18n('Create Operation Comments'),
        group: 'Messenger',
        hasAdditionalPermission: true,
        viewPermission: userPermissions.CREATE_OPERATIONS_COMMENTS
    },
    {
        label: i18n('Create Activity Logs'),
        group: 'Messenger',
        hasAdditionalPermission: true,
        viewPermission: userPermissions.CREATE_ACTIVITY_LOG
    }
]
permissions.forEach(e => LiveApi.Extension.permissions.register(e))
